import type { ShoppingCartModel } from './ShoppingCart.api.model';

export type ShoppingCart = ShoppingCartModel;

export const mapApiModelToShoppingCart = (
  apiModel: ShoppingCartModel,
): ShoppingCart => ({
  SelectedDownPayments: apiModel.SelectedDownPayments,
  CartItems: apiModel.CartItems,
  AppliedDiscounts: apiModel.AppliedDiscounts ?? [],
  SubTotals: apiModel.SubTotals,
  EnableBuyback: apiModel.EnableBuyback ?? false,
  NumberSelections: apiModel.NumberSelections ?? [],
  DiscountCouponCodes: apiModel.DiscountCouponCodes ?? [],
  CustomerRequiresAuth: apiModel.CustomerRequiresAuth ?? true,
});
